import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';
import { brandsAPI, uploadsAPI } from '../services/api';
import { manufacturers as fallbackNames } from '../data/mockData';
import { brandPath } from '../services/brandLogos';
import { useT } from '../services/i18n';

const ManufacturersSection = () => {
  const { t } = useT();
  const [brands, setBrands] = useState(null);

  useEffect(() => {
    brandsAPI.getAll()
      .then(list => setBrands(list.filter(b => b.product_count > 0)))
      .catch(() => setBrands(fallbackNames.map(name => ({ name, logo: '', product_count: 0 }))));
  }, []);

  const list = brands || fallbackNames.map(name => ({ name, logo: '', product_count: 0 }));
  const sorted = [...list].sort((a, b) => (b.logo ? 1 : 0) - (a.logo ? 1 : 0) || a.name.localeCompare(b.name));

  return (
    <section className="py-6 sm:py-10 bg-gray-50" data-testid="manufacturers-section">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">
          {t('home.manufacturers')}
        </h2>

        <div className="flex flex-wrap gap-3">
          {sorted.map((b) => (
            <Link
              key={b.name}
              to={brandPath(b)}
              data-testid={`manufacturer-link-${b.name}`}
              title={b.product_count ? `${b.product_count} produit${b.product_count > 1 ? 's' : ''} ${b.name}` : b.name}
              className="h-12 px-5 bg-white border border-gray-200 rounded-md text-sm font-medium text-gray-700 hover:border-orange-500 hover:text-orange-600 hover:shadow-sm transition-all inline-flex items-center gap-2"
            >
              {b.logo ? (
                <img src={uploadsAPI.resolveUrl(b.logo)} alt={b.name} className="h-7 max-w-[110px] object-contain no-placeholder" data-testid={`manufacturer-logo-${b.name}`} />
              ) : (
                <span data-testid={`manufacturer-name-${b.name}`}>{b.name}</span>
              )}
              {b.total_reviews > 0 && (
                <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-gray-700 bg-yellow-50 border border-yellow-200 rounded-full px-1.5 py-0.5" data-testid={`manufacturer-rating-${b.name}`} title={`${Number(b.avg_rating).toFixed(1)}/5 · ${b.total_reviews} avis`}>
                  <Star size={10} className="fill-yellow-400 text-yellow-400" /> {Number(b.avg_rating).toFixed(1)} <span className="font-normal text-gray-400">({b.total_reviews})</span>
                </span>
              )}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ManufacturersSection;
